import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CVA} from './cva';
import {UIFormEngineComponentMetadata} from './form';
import {QARService} from '../../services/qar.service';


@Component({
	selector: 'ui-input-email-list',
	templateUrl: 'input-email-list.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => UIInputEmailListComponent),
			multi: true
		}
	]
})
export class UIInputEmailListComponent extends CVA {


	@Input() metadata: UIFormEngineComponentMetadata;
	@Input() name;
	@Input() api: QARService;
	@Input() presentationMode = false;
	@Output() onChange = new EventEmitter();

	writeValue(obj: any) {
		// if (obj) {
		this.cva.value = obj;
		this.cva.onChangeFunction(obj);
		this.cva.onTouchedFunction(obj);
		if (obj) {
			this.data.emails = obj;
		} else {
			this.data.emails = [];
		}
	}

	public data = {
		newEmail: '',
		emails: [],
		validating: false,
		error: false,
		errorDuplicate: false,
		selected: []
	};

	public kindaValidEmail(w) {
		// console.log('kindaValidEmail', w, w.length, w.indexOf('@'));
		return w.length >= 12 && w.indexOf('@') !== -1;
	}

	public length(w) {
		return w.length;
	}


	public removeEmails($event) {
		console.log('sodApprovers_removeEmails', this.data.selected);
		if (this.length(this.data.selected)) {
			const original = this.data;

			const toRemove = [];
			for (const o of $event) {
				if (o.selected) {
					toRemove.push(o.value.trim());
				}
			}
			const toKeep = [];
			for (const em of this.data.emails) {
				console.log('existing', em);
				if (toRemove.indexOf(em.trim()) === -1) {
					toKeep.push(em);
				}
			}
			console.log(toKeep);
			this.data.selected = [];
			this.data.emails = toKeep;
			this.writeValueFromInput(this.data.emails);
			this.onChange.emit({emails: this.data.emails, action: 'removed'});
		}
	}

	public addToEmails() {
		if (!this.kindaValidEmail(this.data.newEmail)) {
			return;
		}
		if (this.data.newEmail) {
			this.data.newEmail = this.data.newEmail.trim();
		}
		this.data.error = false;
		this.data.errorDuplicate = false;

		let isDuplicate = false;
		// check for duplicate
		for (const email of this.data.emails) {
			if (email === this.data.newEmail) {
				isDuplicate = true;
			}
		}

		if (isDuplicate) {
			this.data.errorDuplicate = true;
		} else {
			this.data.validating = true;
			this.api.validateEmail(this.data.newEmail).then(r => {
				this.data.validating = false;
				if (r['valid']) {
					this.data.emails.unshift(this.data.newEmail);
					this.writeValueFromInput(this.data.emails);
					this.onChange.emit({emails: this.data.emails, action: 'added'});
					this.data.newEmail = '';
				} else {
					this.data.error = true;
				}
			});
		}
	}

}
